import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Display from '../parts/display';
import * as siteActions from '../../actions/siteActions';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';


class TermsPage extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false,
			selected: '',
			pageSlug: false
		};
	}
	componentWillMount() {
		window.scrollTo(0, 0);
		if (!this.props.site.termsPage) {
			this.props.actions.loadTermsPage();
		}
	}
	componentDidMount() {
		this.props.actions.showNavBar(true);
		this.props.actions.showMenu(true);

		if (this.props.site.posts.length < 4) {
			this.props.actions.loadBlogPosts(3, 1);
		}
	}
	render() {
		return (

			<div className="services-page animated fadeIn portfolio-page privacy-page">
				<div className="portfolio-top">
					<div className="container">
						<div className="row">
							<h1><span>/</span> Terms & Conditions</h1>
							<div className="dash-separator"></div>
						</div>
					</div>
				</div>
				<div className="page-content">
					<div className="container">
						<div className="row">
							<Display if={this.props.site.termsPage}>
								<div className="text-content" dangerouslySetInnerHTML={{ __html: this.props.site.termsPage.content ? this.props.site.termsPage.content.rendered : '' }}></div>
							</Display>
						</div>
					</div>
				</div>
				<BlogBlock posts={this.props.site.posts} maxPosts={3} loading={this.props.site.loadingPosts} />
				<ClientsBlock clients={this.props.site.selectedClients} />
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/about/termsPage.js
 **/